export const typeDefs = `
  union InternalTransactionsListSortType = date | username | status | trxId | trxType | amountMbtc

  input InternalTransactionsListFilterInput {
    date: [String]
    username: String
    trxId: [String]
    trxType: String
    status: String
    amountMbtc: [Float]
  }

  input InternalTransactionInputMutation {
    idToken: String!
    username: String!
    amount: Float!
  }
`;
